export var decodeMessage = function (message) {
    var _a;
    try {
        var _b = JSON.parse(message), event_1 = _b.event, channel = _b.channel, data = _b.data, code = _b.code, uri = _b.uri;
        var _c = uri.split(':'), service = _c[0], action = _c[1];
        switch (service) {
            case 'channel':
                return {
                    type: '__ChannelEvent',
                    action: action,
                    event: event_1,
                    channel: channel,
                    data: data,
                    code: code,
                };
            case 'root':
                return {
                    type: '__RootMessage',
                    action: action,
                    code: code,
                    message: message,
                };
            default:
                return {
                    type: '__ErrorEvent',
                    code: 500,
                    action: action !== null && action !== void 0 ? action : 'error',
                    message: "Unrecognisable message: ".concat(message),
                };
        }
    }
    catch (e) {
        return {
            type: '__ErrorEvent',
            code: (_a = parseInt(e.code)) !== null && _a !== void 0 ? _a : 500,
            action: 'error',
            message: e.message,
        };
    }
};
export var encodeMessage = function (message) {
    delete message.type;
    return JSON.stringify(message);
};
